{{loadFocustelements()}}
<div  class="message-modal" (keydown)="handleKeydown($event)" >
    <div class="modal-header">
        <h2 aria-hidden="true"> </h2>
    </div>
    <div class="corner-button">
        <button class="close" aria-label="Close Modal Popup" (click)="cancelModal(false)">x</button>
    </div>
    <div tabindex="0" id="modalVideo" class="gvp-modal-body">
            <att-gvp  [attr.video]="videoId" (click)="adobeLinkClick()"></att-gvp>
    </div>   
    <h2 aria-hidden="true" tabindex="0"></h2>    
</div>


